import { useEffect, useState, type ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { isFixtureMode } from "../lib/memberService";
import { supabase } from "../lib/supabase";

export function RouteGuard({ children, admin = false }: { children: ReactNode; admin?: boolean }) {
  const [state, setState] = useState<"loading" | "allowed" | "denied">(
    isFixtureMode ? "allowed" : "loading",
  );

  useEffect(() => {
    if (isFixtureMode) return;
    let active = true;
    async function verify() {
      if (!supabase) return active && setState("denied");
      const { data } = await supabase.auth.getSession();
      if (!data.session) return active && setState("denied");
      if (!admin) return active && setState("allowed");
      const { data: role } = await supabase.from("member_roles").select("role")
        .eq("user_id", data.session.user.id).eq("role", "admin").maybeSingle();
      if (active) setState(role ? "allowed" : "denied");
    }
    void verify();
    return () => { active = false; };
  }, [admin]);

  if (state === "loading") return <main className="login-shell"><h1>Checking access…</h1></main>;
  if (state === "denied") return <Navigate to="/login" replace />;
  return children;
}
